import { render } from "./day-three-morning.vue?vue&type=template&id=567a6c06"
import script from "./day-three-morning.vue?vue&type=script&lang=js"
export * from "./day-three-morning.vue?vue&type=script&lang=js"
script.render = render

export default script